import { Inject, Injectable } from '@angular/core';
import { AUTOMATION_CONTEXT_INJECTION_TOKEN } from './injection-tokens';
import { Context } from '@vendasta/automata';

@Injectable({ providedIn: 'root' })
export class AutomataContextService {
  constructor(@Inject(AUTOMATION_CONTEXT_INJECTION_TOKEN) private readonly automationContext: Context) {}

  public get currentContext(): Context {
    return this.automationContext;
  }
}
